import { callService } from "@Views/utils/ServiceUtils";
import { getLanguage, isEmpty, langChangeMsg, replace, setNumberComma } from "@Views/utils/StringUtils";
import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";

const Search = ({ url, msg }: any) => {
    const params: any = useParams();
    const history = useHistory();
    const language = getLanguage();
    const searchTextRef = useRef<any>();

    const [activeTab, setActiveTab] = useState<string>('allList');
    const [searchData, setSearchData] = useState<any>({ allList: [], statItemList: [], statClfList: [], etcList: [], sdSrwrMngMList: [] });
    const [selectedPagination, setSelectedPagination] = useState<number>(1);

    const tabList = ['allList', 'statClfList', 'statItemList', 'etcList'];

    const OSUSE05R01 = async () => {
        //kkh
        const param = {
            srwrDvCd: '01',
            langCd: language,
            srwrNm: decodeURIComponent(params['text']),
            useYn: 'Y'
        }
        const res = await callService("OSUSE05R01", param);

        return res['sdSrwrMngMList'];
    }


    const OSUUA02R04 = async () => {

        const param: any = {};
        const titleKey = langChangeMsg('searchTtlNm', 'searchTtlEngNm');
        const ctntTitleKey = langChangeMsg('searchCtntTtlNm', 'searchCtntTtlEngNm');
        const ctntKey = langChangeMsg('searchCtnt', 'searchEngCtnt');
        const text = decodeURIComponent(params['text']);
        param[titleKey] = text;

        const res = await callService("OSUUA02R04", param);

        let keywordList = [];

        if (res['keywordList']) {
            keywordList = res['keywordList'];
        }

        for (const tabListItem of tabList.slice((1))) {

            for (const item of res[tabListItem]) {

                if (tabListItem !== 'etcList') {
                    if (item[titleKey]) {
                        const num = item[titleKey].substring(0, item[titleKey].indexOf('. ') + 1);
                        const navList = [];
                        let navOld = "";
                        const navItemSplit = num.substring(0, num.length - 1).split('.');

                        for (const navItem of navItemSplit) {
                            if (isEmpty(navOld)) {
                                navOld = navItem;
                            } else {
                                navOld += '.' + navItem;
                            }
                            navList.push(navOld);
                        }

                        item['searchTtlNum'] = num;
                        item['searchTtlNm'] = replace(item[titleKey], item['searchTtlNum'], '');
                        navList[navList.length - 1] += item[titleKey];
                        item['searchTtlNavList'] = navList;
                    }
                }

                if (item[titleKey]) {
                    item[titleKey] = replace(item[titleKey], text, '<mark>' + text + '</mark>');
                    item[titleKey] = replace(item[titleKey], text.toUpperCase(), '<mark>' + text.toUpperCase() + '</mark>');
                    for (const keyword of keywordList) {
                        if (keyword.length > 1) {
                            item[titleKey] = replace(item[titleKey], keyword, '<mark>' + keyword + '</mark>');
                            item[titleKey] = replace(item[titleKey], keyword.toUpperCase(), '<mark>' + keyword.toUpperCase() + '</mark>');
                        }
                    }
                }
                if (item[ctntTitleKey]) {
                    item[ctntTitleKey] = replace(item[ctntTitleKey], text, '<mark>' + text + '</mark>');
                    item[ctntTitleKey] = replace(item[ctntTitleKey], text.toUpperCase(), '<mark>' + text.toUpperCase() + '</mark>');
                    for (const keyword of keywordList) {
                        if (keyword.length > 1) {
                            item[ctntTitleKey] = replace(item[ctntTitleKey], keyword, '<mark>' + keyword + '</mark>');
                            item[ctntTitleKey] = replace(item[ctntTitleKey], keyword.toUpperCase(), '<mark>' + keyword.toUpperCase() + '</mark>');
                        }
                    }
                }
                if (item[ctntKey]) {
                    item[ctntKey] = replace(item[ctntKey], text, '<mark>' + text + '</mark>');
                    item[ctntKey] = replace(item[ctntKey], text.toUpperCase(), '<mark>' + text.toUpperCase() + '</mark>');
                    for (const keyword of keywordList) {
                        if (keyword.length > 1) {
                            item[ctntKey] = replace(item[ctntKey], keyword, '<mark>' + keyword + '</mark>');
                            item[ctntKey] = replace(item[ctntKey], keyword.toUpperCase(), '<mark>' + keyword.toUpperCase() + '</mark>');
                        }
                    }
                }
            }
        }

        const sdSrwrMngMList = await OSUSE05R01();

        res['sdSrwrMngMList'] = sdSrwrMngMList;

        setSearchData(res);
    }

    const selectSearch = (keyword: string) => {
        if (isEmpty(keyword.trim())) {
            alert(msg['searchPlaceHolder']);
        } else {
            history.push(url + "/" + keyword);
        }
    }

    const getAllCount = () => {
        let count = 0;

        for (const item of tabList.slice((1))) {
            count += searchData[item]['length'];
        }

        return setNumberComma(count);
    }

    const itemClick = (e: any, item: any) => {
        const classList = e['target']['classList'];
        if (classList.contains('linkList-nav-item') === false && classList.contains('txt-more') === false) {
            const inptParmVal = JSON.parse(item['inptParmVal']);
            history.push({ pathname: '/' + item['lkdScrId'], state: inptParmVal });
        }
    }

    const navItemClick = (item: any, level: number) => {

        const inptParmVal = JSON.parse(item['inptParmVal']);

        const dsId = inptParmVal['dsId'];
        const state: any = {
            dsId: dsId,
            level: (level + 1)
        };

        history.push({ pathname: '/SearchStat', state: state });
    }

    const onClickBtnPagination = (type: string, selectedNumber: number) => {

        let paginationCount = searchData[activeTab].length === 0 ? 1 : Math.ceil(searchData[activeTab].length / 10);
        let pageNumber = 1;

        if (type === 'page') {
            pageNumber = selectedNumber;
        }
        else if (type === 'first') {
            pageNumber = 1;
        }
        else if (type === 'before') {
            if (selectedPagination !== 1)
                pageNumber = (selectedPagination - 1);
            else
                pageNumber = 1;
        }
        else if (type === 'after') {
            if (selectedPagination !== paginationCount)
                pageNumber = (selectedPagination + 1);
            else
                pageNumber = selectedPagination;
        }
        else if (type === 'last') {
            pageNumber = paginationCount;
        }

        setSelectedPagination(pageNumber);
    }

    const renderPagination = () => {

        let paginationCount = searchData[activeTab].length === 0 ? 1 : Math.ceil(searchData[activeTab].length / 10);
        let pageLevel = 1;

        return (
            <>
                {
                    Array.from(Array(paginationCount), (e, i) => {

                        let pageNum = i + 1;
                        let page = <li className={"pagination_btn" + (Math.ceil(selectedPagination / 10) === pageLevel ? '' : ' displayNone')} key={i}><button type="button" className={"list_move" + (selectedPagination === i + 1 ? ' active' : '')} onClick={(e) => onClickBtnPagination('page', pageNum)}>{pageNum}</button></li>;

                        if (pageNum % 10 === 0) {
                            pageLevel++;
                        }

                        return page;
                    })
                }
            </>
        )
    }

    useEffect(() => {
        if (params['text']) {
            searchTextRef['current']['value'] = decodeURIComponent(params['text']);
            OSUUA02R04();
        }
    }, [params])

    useEffect(() => {
        setSelectedPagination(1);
    }, [activeTab])


    return <>
        <div className="wrap-body-center overflow-none">
            <div className="container container-sh">
                <div className="container-top">
                    <div className="top-box centerTitCustom">
                        <div className="top-box-left">
                            <h2 className="pgTit">{msg['title']}</h2>
                        </div>
                    </div>
                </div>

                <div className="searh_wrapStyle01 faq_custom main_search">
                    <div className="searchContainer">
                        <div className="form-group form-group-search">
                            <div className="input-box-group">
                                <div className="input-box">
                                    <input className="form-control" type="text" placeholder={msg['searchPlaceHolder']} onKeyDown={(e) => { if (e.key === 'Enter') { selectSearch(e.currentTarget.value) } }} ref={searchTextRef} /><i></i>
                                </div>
                            </div>
                            <div className="btn-reset">
                                <button type="button" className="btn" onClick={() => { searchTextRef.current.value = '' }}></button>
                            </div>
                            <div className="btn-search btn-search-02">
                                <button type="button" className="btn" onClick={() => { selectSearch(searchTextRef.current.value) }}></button>
                            </div>
                        </div>
                    </div>
                </div>
                {searchData['sdSrwrMngMList'].length !== 0 &&
                    <>
                        <div className="keySearch_terms" style={{ justifyContent: "center" }}>
                            <div className="tit">{msg['relatedSearchTerms']}</div>
                            <div className="keyBtnBox">
                                {
                                    searchData['sdSrwrMngMList'].map((item: any, itemIndex: number) => (
                                        <button key={itemIndex} type="button" className="btn" onClick={(e) => history.push('/Search/' + encodeURIComponent(item['cnnSrwrNm']))}>{'#' + item['cnnSrwrNm']}</button>
                                    ))
                                }
                            </div>
                        </div>
                    </>
                }
                <div className="board_listCompent board_listCompent-02">
                    <div className="boardTop_box">
                        <div className="leftBox">
                            <div className="boardCount_text">
                                '<span className="searchTxt">{decodeURIComponent(params['text'])}</span>'&nbsp;{msg['searchCountMsg']}&nbsp;
                                <span className="count">{getAllCount()}</span>
                                {msg['count']}
                            </div>
                        </div>
                    </div>

                    <div className="tabContainer tabContainer-02 tabContainer-yh">
                        <div className="tabHeader">
                            <div className="tabTitBox">
                                {
                                    tabList.map((item: any, itemIndex: number) => (
                                        <div key={itemIndex} className={"tabTit" + (activeTab === item ? ' active' : '')} onClick={() => setActiveTab(item)}>

                                            {
                                                item === 'allList' ?
                                                    <button type="button" className="btn">{msg[item]}<span className="count">{getAllCount()}</span>{msg['count']}</button>
                                                    :
                                                    <button type="button" className="btn">{msg[item]}<span className="count">{setNumberComma(searchData[item]['length'])}</span>{msg['count']}</button>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className="tabContentsBox">
                            <div className="tabItems active">
                                <div className="board_contentsBox">
                                    {
                                        activeTab === 'allList' ?
                                            tabList.slice((1)).map((tabListItem: any, tabListItemIndex: number) => (
                                                <Fragment key={tabListItemIndex}>
                                                    <h3 className={"list-icon0" + (tabListItemIndex + 1) + " ta_l"}>
                                                        {msg[tabListItem]}
                                                        <a className="see_more" tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { setActiveTab(tabListItem) } }} onClick={() => setActiveTab(tabListItem)}>{msg['seeMore']}</a>
                                                    </h3>
                                                    <ul className="board_list">
                                                        {
                                                            tabListItem !== 'etcList' ?
                                                                searchData[tabListItem].slice(0, 5).map((item: any, itemIndex: number) => (
                                                                    <li className="board_items" key={itemIndex} tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { itemClick(e, item) } }} onClick={(e) => { itemClick(e, item) }}>
                                                                        <div className="board_list_titBox">
                                                                            <div className="leftBox titTxtBox">
                                                                                <div className="board_num">{((selectedPagination - 1) * 10) + (itemIndex + 1)}</div>
                                                                                {
                                                                                    <div className="tit">
                                                                                        <a className="boardLink">
                                                                                            <span className="linkList-tit" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) }} />
                                                                                            <span className="linkList-nav">
                                                                                                {
                                                                                                    item['searchTtlNavList'].map((navItem: any, navItemIndex: number) => (
                                                                                                        <Fragment key={navItemIndex}>
                                                                                                            <span className="linkList-nav-item" tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { navItemClick(item, navItemIndex) } }} onClick={() => navItemClick(item, navItemIndex)}>{navItem}</span>{navItemIndex !== item['searchTtlNavList'].length - 1 && " > "}
                                                                                                        </Fragment>
                                                                                                    ))
                                                                                                }
                                                                                            </span>
                                                                                        </a>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        {langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) &&
                                                                            <div className="board_sum">
                                                                                <p className="txt" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) }}></p>
                                                                                <div className="txt-add">
                                                                                    <button type="button" className="btn txt-more" onClick={(e) => {
                                                                                        const that: any = e['target'];
                                                                                        that['style']['display'] = 'none'
                                                                                        that['parentNode']['parentNode'].querySelector('.txt')['style']['webkitLineClamp'] = 9999;
                                                                                    }}>{msg['seeMore']}</button>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </li>
                                                                ))
                                                                :
                                                                searchData[tabListItem].slice(0, 10).map((item: any, itemIndex: number) => (
                                                                    <li className="board_items" key={itemIndex} tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { itemClick(e, item) } }} onClick={(e) => { itemClick(e, item) }}>
                                                                        <div className="board_list_titBox">
                                                                            <div className="leftBox titTxtBox">
                                                                                <div className="board_num">{((selectedPagination - 1) * 10) + (itemIndex + 1)}</div>
                                                                                {item['searchItmCd'] === '04' ?
                                                                                    <>
                                                                                        <div className="cate">{msg['dataInformation']}</div>
                                                                                        <div className="tit">
                                                                                            <a className="boardLink" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) + " - " + langChangeMsg(item['searchCtntTtlNm'], item['searchCtntTtlEngNm']) }} />
                                                                                        </div>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <div className="cate">{msg['statisticsGlossary']}</div>
                                                                                        <div className="tit">
                                                                                            <a className="boardLink" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) }} />
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        {langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) &&
                                                                            <div className="board_sum">
                                                                                <p className="txt" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) }}></p>
                                                                                <div className="txt-add">
                                                                                    <button type="button" className="btn txt-more" onClick={(e) => {
                                                                                        const that: any = e['target'];
                                                                                        that['style']['display'] = 'none'
                                                                                        that['parentNode']['parentNode'].querySelector('.txt')['style']['webkitLineClamp'] = 9999;
                                                                                    }}>{msg['seeMore']}</button>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </li>
                                                                ))
                                                        }
                                                    </ul>
                                                </Fragment>
                                            ))

                                            :
                                            <ul className="board_list">
                                                {
                                                    searchData[activeTab].slice((selectedPagination - 1) * 10, selectedPagination * 10).map((item: any, itemIndex: number) => (
                                                        <li className="board_items" key={itemIndex} tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { itemClick(e, item) } }} onClick={(e) => { itemClick(e, item) }}>
                                                            <div className="board_list_titBox">
                                                                <div className="leftBox titTxtBox">
                                                                    <div className="board_num">{((selectedPagination - 1) * 10) + (itemIndex + 1)}</div>

                                                                    {item['searchItmCd'] === '04' ?
                                                                        <>
                                                                            <div className="cate">{msg['dataInformation']}</div>
                                                                            <div className="tit">
                                                                                <a className="boardLink" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) + " - " + langChangeMsg(item['searchCtntTtlNm'], item['searchCtntTtlEngNm']) }} />
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        item['searchItmCd'] === '05' ?
                                                                            <>
                                                                                <div className="cate">{msg['statisticsGlossary']}</div>
                                                                                <div className="tit">
                                                                                    <a className="boardLink" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) }} />
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <div className="tit">
                                                                                <a className="boardLink">
                                                                                    <span className="linkList-tit" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchTtlNm'], item['searchTtlEngNm']) }} />
                                                                                    <span className="linkList-nav">
                                                                                        {
                                                                                            item['searchTtlNavList'].map((navItem: any, navItemIndex: number) => (
                                                                                                <Fragment key={navItemIndex}>
                                                                                                    <span className="linkList-nav-item" tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { navItemClick(item, navItemIndex) } }} onClick={() => navItemClick(item, navItemIndex)}>{navItem}</span>{navItemIndex !== item['searchTtlNavList'].length - 1 && " > "}
                                                                                                </Fragment>
                                                                                            ))
                                                                                        }
                                                                                    </span>
                                                                                </a>
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>

                                                            {langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) &&
                                                                <div className="board_sum">
                                                                    <p className="txt" dangerouslySetInnerHTML={{ __html: langChangeMsg(item['searchCtnt'], item['searchEngCtnt']) }}></p>
                                                                    <div className="txt-add">
                                                                        <button type="button" className="btn txt-more" onClick={(e) => {
                                                                            const that: any = e['target'];
                                                                            that['style']['display'] = 'none'
                                                                            that['parentNode']['parentNode'].querySelector('.txt')['style']['webkitLineClamp'] = 9999;
                                                                        }}>{msg['seeMore']}</button>
                                                                    </div>
                                                                </div>
                                                            }

                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    activeTab !== 'allList' &&
                    <div className="pagination_box">
                        <ul className="pagination">
                            <li className="pagination_btn">
                                <button type="button" className="list_move list_first" onClick={(e) => onClickBtnPagination('first', 0)} />
                            </li>
                            <li className="pagination_btn">
                                <button type="button" className="list_move list_prev" onClick={(e) => onClickBtnPagination('before', 0)} />
                            </li>
                            {renderPagination()}
                            <li className="pagination_btn">
                                <button type="button" className="list_move list_next" onClick={(e) => onClickBtnPagination('after', 0)} />
                            </li>
                            <li className="pagination_btn">
                                <button type="button" className="list_move list_last" onClick={(e) => onClickBtnPagination('last', 0)} />
                            </li>
                        </ul>
                    </div>
                }
            </div>
        </div>
    </>
}
export default Search;